const TheContainer = () => import("@/containers/TheContainer.vue")
const AdminPayoutList = () => import('./AdminPayoutList.vue')
const AdminPayoutDetail = () => import('./AdminPayoutDetail.vue')

export default [
  {
    path: '/admin/payouts',
    component: TheContainer,
    meta: {perms: ['admin.payouts.list']},
    redirect: {name: 'adminPayoutList'},
    children: [
      {
        path: '',
        name: 'adminPayoutList',
        component: AdminPayoutList,
        meta: {label: 'Admin Payouts'}
      },
      {
        path: ':id',
        name: 'adminPayoutDetail',
        component: AdminPayoutDetail,
        meta: {label: 'Payout Detail'}
      }
    ]
  }
]